import { IDocumentResponse } from "@finbackoffice/clientbff-client";
import { useState, useCallback, useEffect, useContext, useMemo } from "react";
import { DocumentType } from "@finbackoffice/enums";
import { ClientBFFContext } from "../providers";

export const useUserDocuments = () => {
    const client = useContext(ClientBFFContext);
    const [documents, setDocuments] = useState<IDocumentResponse[]>([]);
    const [loading, setLoading] = useState(true);

    const recentCreatedDocs = useMemo(
        () => ({
            [DocumentType.IDENTITY_DOCUMENT]: documents.filter(
                (doc) => doc.document_type === DocumentType.IDENTITY_DOCUMENT,
            ),
            [DocumentType.ADDRESS]: documents.filter(
                (doc) => doc.document_type === DocumentType.ADDRESS,
            ),
            [DocumentType.PAYMENT]: documents.filter(
                (doc) => doc.document_type === DocumentType.PAYMENT,
            ),
        }),
        [documents],
    );

    const docStatus = useMemo(
        () => ({
            [DocumentType.IDENTITY_DOCUMENT]:
                recentCreatedDocs[DocumentType.IDENTITY_DOCUMENT][0]?.status,
            [DocumentType.ADDRESS]: recentCreatedDocs[DocumentType.ADDRESS][0]?.status,
            [DocumentType.PAYMENT]: recentCreatedDocs[DocumentType.PAYMENT][0]?.status,
        }),
        [recentCreatedDocs],
    );

    const loadDocuments = useCallback(async () => {
        const loadData = async () => {
            setLoading(true);
            const response = await client.getUserDocuments();
            setLoading(false);
            return response.items;
        };
        const response = await loadData();
        setDocuments(response);
    }, [client]);

    useEffect(() => {
        loadDocuments();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        loadDocuments,
        loading,
        recentCreatedDocs,
        docStatus,
    };
};
